import { render, staticRenderFns } from "./Trending.vue?vue&type=template&id=0d1d7e48&scoped=true"
import script from "./Trending.vue?vue&type=script&lang=js"
export * from "./Trending.vue?vue&type=script&lang=js"
import style0 from "./Trending.vue?vue&type=style&index=0&id=0d1d7e48&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1d7e48",
  null
  
)

export default component.exports